export default __webpack_public_path__ + "static/media/LOGO_UAS.8c4be412.png";